<div class="error">
  <mat-icon class="icon">error</mat-icon>
  @if (error) {
    {{ prefix + error.key | translate: error.params }}
  } @else if (key) {
    {{ prefix + key | translate }}
  }
</div>
